export const BRAND_LOGO_URL = 'https://customer-assets.emergentagent.com/job_240d6668-9031-43d2-bd4e-f0c0886a88e6/artifacts/9yynps1l_BLACKLINE%20PROFESSIONALS%20-%20LOGO.jpeg';

export const BROCHURE_URL = 'https://customer-assets.emergentagent.com/job_240d6668-9031-43d2-bd4e-f0c0886a88e6/artifacts/ljztgsvo_WhatsApp%20Image%202026-05-24%20at%2023.13.17%20%282%29.jpeg';

export const HERO_FIVE_STAR_IMAGE = 'https://customer-assets.emergentagent.com/job_240d6668-9031-43d2-bd4e-f0c0886a88e6/artifacts/33r5ibum_WhatsApp%20Image%202026-05-24%20at%2023.13.18.jpeg';

export const AVIATION_HANGAR_IMAGE = 'https://static.prod-images.emergentagent.com/jobs/240d6668-9031-43d2-bd4e-f0c0886a88e6/images/2bca7d28240363d6303bb3aabb67d50ca4eca9090330ccf5596fafb48058ddf1.png';

export const campaignImages = [
  'https://customer-assets.emergentagent.com/job_240d6668-9031-43d2-bd4e-f0c0886a88e6/artifacts/33r5ibum_WhatsApp%20Image%202026-05-24%20at%2023.13.18.jpeg',
  'https://customer-assets.emergentagent.com/job_240d6668-9031-43d2-bd4e-f0c0886a88e6/artifacts/kizrh1uf_WhatsApp%20Image%202026-05-24%20at%2023.13.17.jpeg',
  'https://customer-assets.emergentagent.com/job_240d6668-9031-43d2-bd4e-f0c0886a88e6/artifacts/ljztgsvo_WhatsApp%20Image%202026-05-24%20at%2023.13.17%20%282%29.jpeg',
  'https://customer-assets.emergentagent.com/job_240d6668-9031-43d2-bd4e-f0c0886a88e6/artifacts/yjijpday_WhatsApp%20Image%202026-05-24%20at%2023.13.17%20%281%29.jpeg',
  'https://customer-assets.emergentagent.com/job_240d6668-9031-43d2-bd4e-f0c0886a88e6/artifacts/uy9k68te_BLACKLINE%20-%20BROCHURE.jpeg',
];

export const expandedServices = [
  'Driveway & paving cleaning',
  'Driveway & paving maintenance',
  'Gutters & downpipes cleaning',
  'Gutters & downpipes maintenance',
  'Window & skylight cleaning',
  'Roof cleaning',
  'Roof maintenance',
  'Roofing repair',
  'Drainage & chimneys cleaning',
  'Walls & facades maintenance',
  'Solar panels cleaning',
  'High pressure restoration',
  'Chemical soft washing',
  'Surface prepping',
  'Coatings & painting',
  'Surface repairs',
  'Waterproofing',
  'Restorations',
  'Sanitisation',
  'Pest control & prevention',
  'Padel & tennis courts maintenance',
  'Facility support',
  'Garden upkeep',
  'Replanting',
  'Professional layout & inspection',
  'All gardening services',
  'Hangar cleaning & maintenance',
  'Facility & office cleaning',
  'Aircraft exterior cleaning',
  'Pressure cleaning & surface restoration',
  'Compliance & sanitation support',
  'Scheduled maintenance programs',
];

export const serviceCategoryVisuals = [
  {
    id: 'aviation',
    title: 'Aviation Cleaning',
    image: AVIATION_HANGAR_IMAGE,
    points: ['Hangar cleaning', 'Aircraft exterior detailing', 'Compliance-led sanitation'],
  },
  {
    id: 'padel',
    title: 'Padel Court Maintenance & Cleaning',
    image: 'https://customer-assets.emergentagent.com/job_240d6668-9031-43d2-bd4e-f0c0886a88e6/artifacts/03o1x9wj_BLACKLINE%20PADEL%20MAINTENANCE%20IMAGE.jpeg',
    points: ['Glass and fence detailing', 'Court surface scrubbing', 'Scheduled court care plans'],
  },
  {
    id: 'maintenance',
    title: 'Maintenance',
    image: 'https://customer-assets.emergentagent.com/job_240d6668-9031-43d2-bd4e-f0c0886a88e6/artifacts/geqpmdm9_BLACKLINE%20MAINTENANCE%20IMAGE.jpeg',
    points: [
      'Permanent on-site handyman support',
      'Daily maintenance repairs (tiles, lights, minor electrical)',
      'Wall repairs, painting and practical upkeep',
      'Waterproofing services and leak detection & mitigation',
      'Galvanised / Chromadek roofing repair support',
    ],
  },
  {
    id: 'gardening',
    title: 'Gardening Services',
    image: 'https://customer-assets.emergentagent.com/job_240d6668-9031-43d2-bd4e-f0c0886a88e6/artifacts/blfzp2n8_BLACKLINE%20GARDENING%20IMAGE.jpeg',
    points: ['Garden cleanups and shaping', 'Plant care and lawn maintenance', 'Scheduled gardening service plans'],
  },
];
